import PropTypes from 'prop-types';
import { Image, ImageKeys } from '@components/image';
import { Button, ButtonTypes, ButtonSizes } from '@leegality/leegality-react-component-library';
import { useUser, useCpName, useCpId } from '@app/profile-selection-store';
import { useNavigate } from 'react-router-dom';
import { iconRenderer, IconKeys, IconColors } from '@components/icon';
import { LocaleSelector } from '@components/locale-selector';
import { RL } from '@constants';
import Profile from './profile/profile';

const TopBar = ({ logoPath }) => {
  const user = useUser();
  const cpName = useCpName();
  const cpId = useCpId();
  const navigate = useNavigate();
  const profileLabel = cpName || cpId;

  const handleGoToSelectProfile = () => navigate(`/${RL.SELECT_PROFILE}`);

  return (
    <header className="z-40 flex items-center justify-between bg-white shadow min-h-16 px-4 md:px-6">
      <div className="flex items-center gap-3">
        {logoPath ? <img src={logoPath} alt="logo" className="h-10" /> : (
          <Image
            imgKey={ImageKeys.ConsentIn}
            className="h-6"
            onClick={handleGoToSelectProfile}
          />
        )}
      </div>
      <div className="flex items-center gap-4">
        <LocaleSelector />
        {profileLabel && (
          <div className="md:hidden [&_.btn-cont]:rounded-full">
            <Button
              type={ButtonTypes.SECONDARY}
              size={ButtonSizes.XX_SMALL}
              label={profileLabel}
              renderIcon={() => iconRenderer({ iconName: IconKeys.ChevronRight, size: 14, color: IconColors.GRAY })}
              onClick={handleGoToSelectProfile}
            />
          </div>
        )}
        {user && <div className="hidden md:block"><Profile userProfile={user} /></div>}
      </div>
    </header>
  );
};

TopBar.defaultProps = {
  logoPath: '',
};

TopBar.propTypes = {
  logoPath: PropTypes.string,
};

export default TopBar;
